export const LinksKeys = {
    TermsAndCondition: 'https://help.ableapp.com/en/articles/5590061-eula',
    PrivacyPolicy: 'https://help.ableapp.com/en/articles/5590060-privacy-notice',
    RefundPolicy: 'https://help.ableapp.com/hc/able/articles/1694789184-refund-policy'
};
